import { Toaster as SonnerToaster } from "sonner";
import { useColorModeContext } from "../color-mode/color-mode-provider";
import { cn } from "../utils/cn";

export function Toaster() {
	/** Context */
	const { colorMode } = useColorModeContext();

	/** Render */
	return (
		<SonnerToaster
			richColors
			theme={colorMode}
			position="bottom-right"
			toastOptions={{
				classNames: {
					toast: cn(
						"bg-white! dark:bg-primary-900! border-primaryGray-200! dark:border-primaryGray-800!",
						"rounded-base! shadow-none!",
						"border-[0.5px]!",
					),
					title: cn("text-sm text-black! dark:text-white!"),
					description: "description",
					actionButton: "action-button",
					cancelButton: "cancel-button",
					closeButton: "close-button",
				},
			}}
		/>
	);
}
